export default {
    entityKey: 'testing-runs',
    basePath: '/test-runs',
    titles: {
        singular: 'Test Run',
        plural: 'Test Runs'
    }
}
